import moment from "moment";

export const arrayObjToObjArray = array => {

    /**
     *
    * @param [
        {
            key1: value,
            key2: value2,
        },
        {
            key1: value3,
            key2: value4,
        },
        {
            key1: value5,
            key2: value6,
        },
        ...
    ]
    * @returns {
        key1: [value, value3, value5],
        key2: [value2, value4, value6]
      }
    */
    let newObj = {};
    if (typeof array !== 'undefined' || array !== null) {
        let keys = Object.keys(array[0]);
        keys.forEach(key => {
            newObj[key] = array.reduce(
                (objects, obj) => ((objects || []).push(obj[key]), objects), []
            );
        });
    }
    return newObj;
}

export const orderByDate = function( a, b, key ) {
    let orderA = moment(a[key]).format("YYYY-MM-DD");
    let orderB = moment(b[key]).format("YYYY-MM-DD");
    if (orderA < orderB) return 1;
    else if (orderA > orderB) return -1;
    else return 0;
}
